import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useLocalizedLink } from '../../hooks/useLocalizedLink';

function ServiceInner() {
  const { t } = useTranslation();
  const getLocalizedPath = useLocalizedLink();

  // Her hizmet için uygun banner görseli
  const serviceBannerImages = {
    'single-room': '/assets/img/2-3-kisilik/2-3-kisilik-dikey (1).jpeg',
    'double-room': '/assets/img/2-3-kisilik-yatay/2-3-kisilik-yatay (1).jpeg',
    'triple-room': '/assets/img/2-3-kisilik/2-3-kisilik-dikey (2).jpeg',
    'quad-room': '/assets/img/yurt-fotograf/3-kisilik-on-cephe-106/14.jpg',
    'six-room': '/assets/img/yurt-fotograf/3-kisilik-on-cephe-106/17.jpg',
    'social-areas': '/assets/img/yurt-fotograf/yemekhane/5.jpg',
    'transportation': '/assets/img/yurt-fotograf/dis-cephe/33.jpg',
    'nearby-places': '/assets/img/yurt-fotograf/dis-cephe/36.jpg',
    'nearby-universities': '/assets/img/yurt-fotograf/dis-cephe/40.jpg',
    'general-photos': '/assets/img/yurt-fotograf/teras/7.jpg',
  };

  const serviceSections = [
    { id: 'single-room', key: 'singleRoom' },
    { id: 'double-room', key: 'doubleRoom' },
    { id: 'triple-room', key: 'tripleRoom' },
    { id: 'quad-room', key: 'quadRoom' },
    { id: 'six-room', key: 'sixRoom' },
    { id: 'social-areas', key: 'socialAreas' },
    { id: 'transportation', key: 'transportation' },
    { id: 'nearby-places', key: 'nearbyPlaces' },
    { id: 'nearby-universities', key: 'nearbyUniversities' },
    { id: 'general-photos', key: 'generalPhotos' },
  ];

  return (
    <section className="position-relative overflow-hidden space" id="service-sec">
      <div className="container shape-mockup-wrap">
        <div className="title-area text-center mb-60">
          <span className="sub-title">{t('service.title')}</span>
          <h2 className="sec-title">{t('service.title')}</h2>
        </div>

        <div className="service-sections">
          {serviceSections.map((section, index) => (
            <div key={section.id} id={section.id} className="service-section mb-80">
              <div className="row align-items-center">
                <div className={`col-lg-6 ${index % 2 === 1 ? 'order-lg-2' : ''}`}>
                  <div className="service-image global-img">
                    <img
                      src={serviceBannerImages[section.id] || `/assets/img/normal/service_${index + 1}.jpg`}
                      alt={`Haseki Sultan Kız Öğrenci Yurdu - ${t(`service.${section.key}.title`)}`}
                      title={`Haseki Sultan Kız Öğrenci Yurdu - ${t(`service.${section.key}.title`)}`}
                      onError={(e) => {
                        e.target.src = '/assets/img/normal/resort_1_1.jpg';
                      }}
                    />
                  </div>
                </div>
                <div className={`col-lg-6 ${index % 2 === 1 ? 'order-lg-1' : ''}`}>
                  <div className="service-content">
                    <h3 className="box-title mb-30">
                      {t(`service.${section.key}.title`)}
                    </h3>
                    <p 
                      className="box-text mb-30"
                      dangerouslySetInnerHTML={{ __html: t(`service.${section.key}.description`) }}
                    />
                    {section.key === 'generalPhotos' ? (
                      <Link
                        to={getLocalizedPath('/gallery')}
                        className="th-btn style3"
                      >
                        {t('nav.gallery')}
                      </Link>
                    ) : (
                      <Link
                        to={getLocalizedPath(`/service/${section.id}`)}
                        className="th-btn style3"
                      >
                        {t('common.viewDetails')}
                      </Link>
                    )}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Quick Navigation */}
        <div className="service-navigation mt-60">
          <div className="row">
            <div className="col-12">
              <div className="title-area text-center mb-40">
                <h3 className="box-title">{t('nav.services')}</h3>
              </div>
              <div className="service-links text-center">
                <div className="row g-3">
                  {serviceSections.map((section) => (
                    <div key={section.id} className="col-lg-4 col-md-6">
                      {section.key === 'generalPhotos' ? (
                        <Link
                          to={getLocalizedPath('/gallery')}
                          className="service-link-btn th-btn style4"
                        >
                          {t(`service.${section.key}.title`)}
                        </Link>
                      ) : (
                        <Link
                          to={getLocalizedPath(`/service/${section.id}`)}
                          className="service-link-btn th-btn style4"
                        >
                          {t(`service.${section.key}.title`)}
                        </Link>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Shapes */}
        <div className="shape-mockup shape1 d-none d-xxl-block" style={{ bottom: "17%", right: "-9%" }}>
          <img src="/assets/img/shape/shape_1.png" alt="shape" />
        </div>
        <div className="shape-mockup shape2 d-none d-xl-block" style={{ bottom: "8%", right: "-8%" }}>
          <img src="/assets/img/shape/shape_2.png" alt="shape" />
        </div>
        <div className="shape-mockup shape3 d-none d-xxl-block" style={{ bottom: "15%", right: "-4%" }}>
          <img src="/assets/img/shape/shape_3.png" alt="shape" />
        </div>
      </div>
    </section>
  );
}

export default ServiceInner;
